import { AxiosResponse } from 'axios';

export abstract class ServiceError extends Error {
  constructor(m: string) {
    super(m);
    Object.setPrototypeOf(this, new.target.prototype);
  }
}

export type AuthErrorType = 'authError' | 'lackOfScope';

export class UnauthorizedError extends ServiceError {}

export class OtherServiceError extends ServiceError {}

export class NotLoggedInError extends ServiceError {}

function errorOfStatus(status: number, resText: string): Error | ServiceError {
  if (status === 401) {
    return new UnauthorizedError(resText);
  }
  return new OtherServiceError(resText);
}

export async function errorOf(response: AxiosResponse): Promise<ServiceError> {
  return errorOfStatus(response.status, response.statusText);
}
